// src/hooks/useMisReservas.js

import { useState, useEffect } from 'react';
import { db } from '../firebase/firebase-config';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { useAuthCliente } from '../context/AuthClienteContext';

export function useMisReservas() {
  const { currentUser } = useAuthCliente();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentUser?.uid || !currentUser?.companyId) {
      setLoading(false);
      return;
    }

    const bookingsRef = collection(db, 'companies', currentUser.companyId, 'bookings');
    
    // ✅ Creamos una consulta que filtra las reservas por el ID del usuario actual
    // y las ordena para mostrar las más próximas primero.
    const q = query(
      bookingsRef, 
      where("userId", "==", currentUser.uid),
      orderBy("bookingTimestamp", "asc")
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const userBookings = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setBookings(userBookings);
      setLoading(false);
    }, (err) => {
      console.error("Error al obtener mis reservas: ", err);
      setError("No se pudieron cargar tus reservas.");
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser?.uid, currentUser?.companyId]);

  return { bookings, loading, error };
}